export const MobileWallet = (params) => {
  return (
    <>
      <div className='relative pt-12' key={params.header}>
        <dl>
          <dt>
            <h3 className='text-xl font-bold leading-6 lg:text-3xl'>{params.header}</h3>
          </dt>
          <dd className='mt-2 object-bottom text-base font-medium opacity-[0.7] sm:text-sm md:text-lg'>
            {params.description}
          </dd>
        </dl>
      </div>
    </>
  );
};
